<template>
  <div class="notes">
    <div v-for="day in days" :key="day.offset">
      <panel>
        <h2>{{day.dayLabel}}</h2>
        <list :items="day.notes" :loading="fetching" :editable="false" @reached-bottom="onReachedBottom">
          <template v-slot:itemDisplay="{ item }">
            <span :style="getItemStyle(item)" @click="toggleActivate(item, day)">
              <span class="weekday" :style="getLabelStyle(day, item)">
                [{{getLabelText(day, item)}}]
              </span> 
              <span>{{item.value}}</span>
            </span>
          </template>
        </list>
      </panel>
    </div>
  </div>
</template>

<script>

import { getDayFromTimestamp, weekdays } from '../assets/js/helpers'

const ONE_DAY_IN_MS = 1000 * 3600 * 24;
const ONE_WEEK_IN_MS = ONE_DAY_IN_MS * 7;

export default {
    name: 'Notes',
    data() {
      return {
        header: 'Relevant',
        localStorageKey: 'new_note_text',
        notes: [],
        skip: 0,
        limit: 15,
        increase: 15,
        fetching: false,
        fetchedEverything: false,
        offsetNotes: []
      }
    },
    methods: {
      toggleActivate(note, day) {
        // const isActivated = note.FinishedNotes.length > 0;

        // if (isActivated) this.deactivateNote(note, day);
        // else this.activateNote(note, day);
      },
      activateNote(note, day) {
        const offsetNoteIndex = this.offsetNotes.findIndex(notes => notes.day === day.day);
        const noteIndex = this.offsetNotes[offsetNoteIndex].notes.findIndex(note_ => note_.id === note.id);
        
        this.offsetNotes[offsetNoteIndex].notes[noteIndex].FinishedNotes.push({})

        this.axios.post(this.config.api + `/notes/activate`, { noteId: note.id, day: day.date.toLocaleDateString() })
          .catch(() => {
            alert('something went wrong');
            window.location.reload();
          })
      },
      deactivateNote(note, day) {
        const offsetNoteIndex = this.offsetNotes.findIndex(notes => notes.day === day.day);
        const noteIndex = this.offsetNotes[offsetNoteIndex].notes.findIndex(note_ => note_.id === note.id);
        
        this.offsetNotes[offsetNoteIndex].notes[noteIndex].FinishedNotes = [];

        this.axios.post(this.config.api + `/notes/deactivate`, { noteId: note.id, day: day.date.toLocaleDateString() })
          .catch(() => {
            alert('something went wrong');
            window.location.reload();
          })
      },
      formatNotes(notes) {
        return notes.map(note => {
          return {
            id: note.id,
            value: note.text,
            loading: false,
            ...note
          }
        });
      },
      getItemStyle(note) {
        let style = '';

        const finished = note.FinishedNotes.length > 0;
        
        if (finished) 
          style += `text-decoration:line-through;`;

        return style;
      },
      getLabelStyle(_day, note) {
        let style = '';

        switch (note.Label.slug) {
          case 'deadline':
            if (note.deadlineTimestamp < Date.now() + ONE_WEEK_IN_MS) {
              style += 'color:red;';
              break;
            }
          default:
            style += `color: ${note.Label.colour};`
        }

        return style;
      },
      getLabelText(_day, note) {
        switch (note.Label.slug) {
          case 'deadline':
            return `${note.Label.name} ${getDayFromTimestamp(note.deadlineTimestamp)}`
          case 'recurring_daily':
            return `Daily`
          case 'recurring_weekly':
            const weekday = weekdays.find(day => day.value === note.weekday);
            return `${weekday.label}`
          default:
            return `${note.Label.name}`
        }
      },
      onReachedBottom() {
        if (this.fetchedEverything) return;
        if (this.fetching) return;

        this.skip += this.increase; 
        this.get();
      },
      get() {
        this.fetching = true;

        this.getByDay(this.limit, this.skip, new Date().getDay(), new Date())
          .then(result => {
            this.fetching = false;

            this.fetchedEverything = result.length < this.increase;

            this.getOffset();
          })
          .catch(error => {
            const isAuthenticationError = error.message.includes('401');

            if (isAuthenticationError)
              return this.$router.push('/authorization')
            else alert(error.message)
          })
      },
      getOffset() {
        this.days.forEach(day => {
          this.getByDay(this.limit, this.skip, day.day, day.date)
              .then(result => {
                this.offsetNotes.push({
                  day: day.day,
                  notes: result
                });
          })
        })
      },
      async getByDay(limit, offset, weekday, date) {
        return new Promise((resolve, reject) => {
          this.axios.get(this.config.api + `/notes/relevant?limit=${limit}&offset=${offset}&day=${weekday}&date=${date.getTime()}`)
            .then(result => {
              resolve(this.formatNotes(result.data));
            })
            .catch(error => {
              reject(error);
            })
        }) 
      }
    },
    computed: {
      days: function() {
        const today = new Date();
        // const today = new Date('2022-6-10');
        return [0, 1, 2, 3, 4, 5, 6].map(offset => {
          const date = new Date(today.getTime() + (ONE_DAY_IN_MS * offset));
          let day = today.getDay() + offset;

          if (day >= 7) day -= 7;

          let dayLabel = weekdays.find(day_ => day_.value === day).label
          dayLabel = `${dayLabel} ${getDayFromTimestamp(date.getTime())}`;

          let notes = [];
          let notesOffset = this.offsetNotes.find(note => note.day === day);
          
          if (notesOffset) notes = notesOffset.notes;
          
          return {
            date,
            offset,
            day,
            dayLabel,
            notes
          }
        })
      }
    },
    created() {
      this.get();
    }
}
</script>

<style scoped>

.notes {
  height: 100%;
}

.panel {
  margin: 0 0 10px 0;
}

</style>


// WEBPACK FOOTER //
// src/components/Relevant.vue